<template>
  <PreviewBase
    v-if="isJobProfile"
    :loading="loading || pageLoading"
  >
    <div class="d-flex flex-column ga-1">
      <div class="text-body-1 text-textDarkest text-center">
        {{ jobProfile?.title }}
      </div>

      <div
        v-if="jobProfile?.title"
        class="d-flex justify-center"
      >
        <JobProfileStatus
          :is-hris-profile="isHrisProfile"
          :is-archived="jobProfile?.is_archived"
          :is-template="isTemplate"
        />
      </div>

      <JobProfileMeta
        :profile="jobProfile"
        class="justify-center"
      />
    </div>

    <div class="d-flex ga-2">
      <router-link
        class="flex-grow-1"
        :to="{
          name: type === 'jobProfileHris' ? 'job-profile-hris-view' : 'job-profile-view',
          params: { id: ulid },
        }"
      >
        <v-btn
          class="w-100"
          variant="flat"
          color="primary"
          rounded="lg"
          @click="onOpenEditorClick"
        >
          Open in Editor
        </v-btn>
      </router-link>
    </div>

    <div class="job-content">
      <div
        v-for="(field, i) in nonEmptyFields"
        :key="field.id"
      >
        <v-divider
          v-if="i > 0"
          class="opacity-100 mt-3 mb-4"
        />

        <div class="text-body-1 text-textDarkest">
          {{ field.label }}
        </div>

        <DocumentPreviewFieldHtml :html="field.headerHtml" />
        <DocumentPreviewFieldHtml :html="field.html" />
        <DocumentPreviewFieldHtml :html="field.footerHtml" />
      </div>
    </div>
  </PreviewBase>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppLoading } from '@/stores/app/loading';
import { useAppRoute } from '@/stores/app/route';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import PreviewBase from '@/components/shared/PreviewBase.vue';
import DocumentPreviewFieldHtml from '@ui/components/general/DocumentPreviewFieldHtml/DocumentPreviewFieldHtml.vue';
import JobProfileStatus from './JobProfileStatus.vue';
import JobProfileMeta from './JobProfileMeta.vue';

const { route } = storeToRefs(useAppRoute());
const { pageLoading } = storeToRefs(useAppLoading());
const {
  jobProfile, nonEmptyFields, isTemplate, isHrisProfile,
} = storeToRefs(useCurrentJobProfile());

const ulid = computed(() => route.value?.query?.preview);
const type = computed(() => route.value?.query?.type);
const loading = ref(false);

const onOpenEditorClick = () => {
  loading.value = true;
};

const isJobProfile = computed(() => ['jobProfile', 'jobProfileHris'].includes(type.value));
const load = () => useCurrentJobProfile().loadJobProfile({
  ulid: ulid.value,
  isHris: type.value === 'jobProfileHris',
  rescore: false,
});

const reset = () => {
  useCurrentJobProfile().resetJobProfile();
  loading.value = false;
};

watch(ulid, () => {
  if (ulid.value && isJobProfile.value) {
    load();
  } else {
    reset();
  }
}, { immediate: true });
</script>
